import Cookies from 'js-cookie';
export default {
    data: function () {
        return {
            cep: '',
            shipping_list: [],
            shipping_unavailable_list: [],
            cep_info: [],
            shipping_msg: '',
            shipping_id: 0,
            carrier_id: 0,
            sending_cep: false
        }
    },
    computed: {
        shipping_type() {
            if (this.shipping_id > 0) {
                let shipping = this.shipping_list.find((el) => parseInt(el.id) === this.shipping_id)
                return shipping['id_tipo']
            }
            return 0
        },
        shipping_condition() {
            let item = {
                id: 0,
                valor_minimo: 0,
                valor_diferenca: 0,
                valor_fixo: 0
            }
            try {
                let shipping = {}
                if (this.shipping_unavailable_list.length) {
                    shipping = this.shipping_unavailable_list.find(el => {
                        return el.display_message === 'true' && el.setar_valor_fixo === 'sim'
                    })
                    if (shipping.id) {
                        item['id'] = shipping['id']
                        item['valor_fixo'] = parseFloat(shipping['valor_fixo'])
                        item['valor_minimo'] = parseFloat(shipping['valor_minimo'])
                        item['valor_diferenca'] = item['valor_minimo'] - parseFloat(this.$store.state.order.order.valor_subtotal)
                    }
                }
            } catch (e) {
                console.error(e)
            }
            return item
        }
    },
    mounted() {
        this.$nuxt.$on('updated_cart', () => {
            this.listShipping()
        })
    },
    methods: {
        async listShipping() {
            let msg_invalid = 'Não foi possível consultar opções de entrega, por favor entre em contato'
            if (this.cep){
                Cookies.set("shipping_cep", this.cep)
            }
            if (this.cep === '' && Cookies.get("shipping_cep")){
                this.cep = Cookies.get("shipping_cep")
                if (this.$store.state.order.order.frete.id){
                    this.shipping_id = this.$store.state.order.order.frete.id
                }
            }
            if (this.cep === '') {
                return false
            }
            try {
                this.sending_cep = true;
                const params = new URLSearchParams();
                params.append('metodo', 'consulta_frete');
                params.append('cep_info', 'sim');
                params.append('tipo', 'pedido');
                params.append('cep', this.cep);
                this.$axios.$post(`/?p=ecommerce_fretes_api_v1`, params)
                    .then((res) => {
                        this.sending_cep = false;
                        if (typeof res === 'object') {
                            this.shipping_msg = 'Sem opções de entrega, por favor entre em contato'
                            this.shipping_list = []
                            this.shipping_unavailable_list = []
                            if (res.list.length) {
                                this.shipping_msg = '';
                                this.shipping_list = res.list
                                this.cep_info = res.cep_info
                            }
                            if ('unavailable_list' in res) {
                                this.shipping_unavailable_list = res.unavailable_list
                            }
                            if (!('cep' in res.cep_info)) {
                                this.shipping_msg = 'Endereço não encontrado';
                            }
                        } else {
                            this.shipping_msg = msg_invalid
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        this.sending_cep = false;
                        this.shipping_msg = msg_invalid
                    })
            } catch (error) {
                console.log(error)
                this.sending_cep = false;
                this.shipping_msg = msg_invalid
            }
        }
    },
    watch: {
        cep(newvalue, oldvalue) {
            this.shipping_msg = ''
        }
    }
}
